// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__R66Fd","title":"styles_title__C+dMC"};